<template>
  <div class="index">
    <div class="header">
      <img class="header-logo" src="@/assets/img/logo.png" alt="">
      <img class="header-img-r" src="@/assets/img/foot_img.png" alt="">
    </div>
    <div class="video-box">
      <!-- <div class="video-modal" @click="clickVideo"></div> -->
      <video id="my-video" :poster="videoItemData.img" webkit-playsinline playsinline x5-playsinline x-webkit-airplay="allow" class="video-js vjs-fluid vjs-big-play-centered">
        <source id="vidoe-url" :src="videoItemData.video" />
      </video>
    </div>
    <div class="text-box">
      <p class="video-title">{{ videoItemData.title }}</p>
      <p class="video-date">{{ videoItemData.videoDate }}</p>
      <p :class="hiddenText ? 'video-content-text-open' : 'video-content-text'" ref="videoContentText">
        {{ videoItemData.content }}
      </p>
      <span class="open-text" v-if="showOpenBtn" @click="openText">{{hiddenText ? '收起' : '展开'}}</span>
      <p class="video-content-text2" ref="videoContentText2">{{ videoItemData.content }}</p>
    </div>
    <!-- <div class="view-price-box">
      <p class="price-btn">新片场内部查看报价</p>
      <img class="right-img" src="../assets/img/right.png" alt="">
    </div> -->
    <a class="click-tel" href="tel:4000210916">咨询影片制作</a>
    <div class="swiper-title-box">
      <p class="swiper-title-left">相关推荐</p>
      <!-- <p class="swiper-title-right">更多</p> -->
    </div>
    <!-- <div class="swiper-pagination"></div> -->
    <div class="swiper-background">
      <swiper class="swiper-box" :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide class="swiper-slide" v-for="(item, index) in videoList" :key="index">
          <div class="video-slide" @click="switchVideo(item, index)">
            <div class="swiper-dialog">
              <span class="user-play" v-show="userSelectNum == index">播放中</span>
            </div>
            <img class="cover-img" :class="index > 2 ?'swiper-lazy':''" :src="index < 3 ? item.img :''" alt="" :data-src="index > 2 ? item.img :''" />
            <div class="cover-text-box">
              <p class="cover-date">{{ item.videoDate }}</p>
              <p class="cover-title">{{ item.title }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- <div class="foot">
      <img class="foot-img" src="@/assets/img/foot_img.png" alt="">
    </div> -->
    <we-chat ref="wxChat" :id="videoItemData.id" :img="videoItemData.img" :title="videoItemData.title"></we-chat>
  </div>
</template>

<script>
import weChat from '@/components/weChat'
import api from '@/api/getVideoData'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'index',
  components: {
    weChat,
    swiper,
    swiperSlide
  },
  data() {
    const _this = this
    return {
      ids: [],
      noRequest: false,
      showOpenBtn: false, // 是否展示文字按钮
      hiddenText: false, // 控制文本是否缩略
      myPlayer: {}, // video.js 实例对象
      playVideo: false, // 控制video遮罩层准备播放视频还是暂停/开启播放
      pageNo: 0,
      userSelectNum: 0,
      servideId: '',
      videoItemData: {
        id: '',
        video: '',
        title: '',
        img: '',
        content: '',
        videoDate: '' // 播放时长
      },
      videoList: [],
      swiperOption: {
        lazy: {
          loadPrevNext: true
        },
        freeMode: true,
        freeModeMomentumRatio: 3,
        freeModeSticky: true,
        // slideToClickedSlide: true,
        // centeredSlides: true,
        slidesPerView: 3,
        spaceBetween: 20,
        on: {
          slideChange: function() {
            // var index = this.activeIndex
            if (this.activeIndex == _this.videoList.length / 2) {
              console.log(this.activeIndex)
              _this.getVideoList()
            }
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    console.log(this.$route.query.id) 
    this.videoItemData.id = parseInt(this.$route.query.id)
    if (this.videoItemData.id) {
      this.ids.push(this.videoItemData.id)
      console.log(location.href.split('=')[0])
      // this.$nextTick(() => {
      this.getItemVideo()
      this.userBrowse()
      // })
    } else {
      window.location.href = 'https://www.aiyaopai.com/QYSP_index.html'
    }
  },
  methods: {
    initVideo() {
      //初始化视频方法
      this.myPlayer = this.$video('my-video', {
        // autoplay: true,
        // autoplay: 'muted',
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: 'auto',
        controlBar: {
          // playToggle: true
          fullscreenToggle: true, //显示全屏按钮，默认为true
          pictureInPictureToggle: false, //隐藏画中画按钮，默认为true
          volumePanel: true, //隐藏声音面板
          durationDisplay: true //显示总时间
        }
      })
      // this.myPlayer.on("loadedmetadata", () => {
      //   this.videoDate = this.getDate(Math.floor(this.myPlayer.duration()));
      //   console.log(this.videoDate);
      // });
      // document.addEventListener(
      //   'WeixinJSBridgeReady',
      //   () => {
      //     this.myPlayer.play()
      //   },
      //   false
      // )
      // this.myPlayer.volume(0)
      // setTimeout(() => {
      //   this.$nextTick(() => {
      //     this.myPlayer.pause()
      //     this.myPlayer.volume(1)
      //   })
      // }, 3000)
    },
    // 通过自定义遮罩层控制点击视频时的播放/暂停
    clickVideo() {
      if (!this.playVideo) {
        this.myPlayer.play()
      } else {
        this.myPlayer.pause()
      }
      this.playVideo = !this.playVideo
    },
    // 点击轮播图切换视频
    switchVideo(item, index) {
      console.log(item)
      console.log(index)
      if (item.id !== this.videoItemData.id) {
        this.videoItemData = Object.assign({}, item)
        this.myPlayer.poster(this.videoItemData.img)
        this.myPlayer.src(this.videoItemData.video)
        this.userSelectNum = index
        var slideIndex = index - 1 < 0 ? 0 : index - 1
        this.swiper.slideTo(slideIndex, 300, false)
        this.$refs.wxChat.init()
        this.hiddenText = false
        var idsIndex = this.ids.indexOf(item.id)
        if (idsIndex === -1) {
          console.log(this.ids)
          this.ids.push(item.id)
          console.log(this.ids)
          this.userBrowse()
        }
        this.$nextTick(() => {
          this.showContentBtn()
        })
        console.log(slideIndex)
        console.log(this.userSelectNum)
        console.log(this.videoItemData)
      }
    },
    // 点击展开文字
    openText() {
      this.hiddenText = !this.hiddenText
    },
    // 转换视频时间文字
    getDate(value) {
      var theTime = parseInt(value) // 秒
      var middle = 0 // 分
      var hour = 0 // 小时
      if (theTime > 60) {
        middle = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (middle > 60) {
          hour = parseInt(middle / 60)
          middle = parseInt(middle % 60)
        }
      }
      var result = '' + parseInt(theTime) + '秒'
      if (middle > 0) {
        result = '' + parseInt(middle) + '分' + result
      }
      if (hour > 0) {
        result = '' + parseInt(hour) + '小时' + result
      }
      return result
    },
    // 获取单个样片
    getItemVideo() {
      api
        .getItemVideo({
          Id: this.videoItemData.id,
          Fields: 'Name,Description,Url,Cover,Duration,Services.Id'
        })
        .then(res => {
          console.log(res)
          if (res.status === 200) {
            ;({
              Url: this.videoItemData.video,
              Name: this.videoItemData.title,
              Cover: this.videoItemData.img,
              Description: this.videoItemData.content,
              Duration: this.videoItemData.videoDate
            } = res.data)
            this.servideId = res.data.Services.Id
            this.videoItemData.videoDate = this.getDate(
              this.videoItemData.videoDate
            )
            this.videoList.push(this.videoItemData)
            this.getVideoList()
            this.$nextTick(() => {
              this.initVideo()
              this.showContentBtn()
            })
          }
        })
    },
    // 获取当前服务项目下的所有样片
    getVideoList() {
      if (!this.noRequest) {
        this.pageNo++
        api
          .getVideoList({
            Fields: 'Id,Name,Description,Url,Cover,Duration',
            PageIndex: this.pageNo,
            PageSize: 6,
            ServicesId: this.servideId,
            Deleted: false
          })
          .then(res => {
            console.log(res)
            if (res.status === 200) {
              var tempArr = Array.from(
                res.data.Result,
                ({
                  Id: id,
                  Cover: img,
                  Url: video,
                  Name: title,
                  Duration: videoDate,
                  Description: content
                }) => ({ id, img, video, title, videoDate, content })
              )
              tempArr.filter((item, index) => {
                item.videoDate = this.getDate(item.videoDate)
                if (item.id !== this.videoItemData.id) {
                  console.log(item.id, this.videoItemData.id)
                  this.videoList.push(item)
                }
                // if (this.pageNo === 1) {
                //   console.log(this.videoItemData.id, item)
                //   if (item.id == this.videoItemData.id) {
                //     console.log(this.userSelectNum)
                //     this.userSelectNum = index
                //     this.$nextTick(() => {
                //       this.swiper.slideTo(this.userSelectNum - 1, 300, false)
                //     })
                //   }
                // }
              })
              if (res.data.Total === this.videoList.length) {
                this.noRequest = true
              }
            }
          })
      }
    },
    // 浏览埋点
    userBrowse() {
      api
        .userBrowse({
          Id: this.videoItemData.id
        })
        .then(res => {
          console.log(res)
        })
    },
    // 判断展示/隐藏 文本区展开按钮
    showContentBtn() {
      // this.showOpenBtn = false
      var el = this.$refs.videoContentText
      var elCopy = this.$refs.videoContentText2
      console.log(el.offsetHeight)
      console.log(elCopy.offsetHeight)
      console.log(el.offsetHeight < elCopy.offsetHeight)
      this.showOpenBtn = el.offsetHeight < elCopy.offsetHeight
    }
  }
}
</script>
<style lang="less" scoped>
.index {
  // height: 100%;
  margin: 0 auto;
  max-width: 375px;
  background-color: #000;
  .header {
    margin-top: 11px;
    margin-bottom: 12px;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    .header-logo {
      width: 115px;
    }
    .header-img-r {
      width: 151px;
    }
  }
  .video-box {
    position: relative;
    .video-modal {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 80%;
      z-index: 999;
    }
    /deep/.vjs-paused .vjs-big-play-button,
    /deep/.vjs-paused.vjs-has-started .vjs-big-play-button {
      display: block;
    }
    /deep/.video-js .vjs-big-play-button {
      font-size: 2.5em;
      line-height: 2.3em;
      height: 2.5em;
      width: 2.5em;
      -webkit-border-radius: 2.5em;
      -moz-border-radius: 2.5em;
      border-radius: 2.5em;
      background-color: #73859f;
      background-color: rgba(115, 133, 159, 0.5);
      border-width: 0.15em;
      margin-left: -1.1em;
    }
    /* 中间的播放箭头 */
    /deep/.vjs-big-play-button .vjs-icon-placeholder {
      font-size: 1.63em;
    }
    /* 加载圆圈 */
    /deep/.vjs-loading-spinner {
      font-size: 2.5em;
      width: 2em;
      height: 2em;
      border-radius: 1em;
      margin-top: -1em;
      margin-left: -1.5em;
    }
    /deep/.video-js.vjs-playing .vjs-tech {
      pointer-events: auto;
    }
    /deep/.video-js .vjs-time-control {
      display: block;
    }
    /deep/.video-js .vjs-remaining-time {
      display: none;
    }
  }
  .text-box {
    position: relative;
    margin: 0 10px;
    .video-title {
      margin-top: 30px;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: normal;
      word-break: break-all;
    }
    .video-date {
      margin-top: 30px;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 14px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      white-space: normal;
      word-break: break-all;
    }
    .video-content-text {
      // position: relative;
      margin-top: 30px;
      height: 95px;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 23px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      white-space: normal;
      word-break: break-all;
    }
    .video-content-text-open {
      margin-top: 30px;
      // height: 90px;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 23px;
    }
    .open-text {
      position: absolute;
      right: 0;
      bottom: -13px;
      color: #2ee9ff;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 12px;
    }
    .video-content-text2 {
      position: absolute;
      top: 0;
      left: 0;
      margin-top: 30px;
      height: auto;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 23px;
      // display: none;
      visibility: hidden;
    }
  }
  .view-price-box {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .price-btn {
      font-size: 14px;
      color: #2ee9ff;
      letter-spacing: 0;
      text-align: center;
    }
    .right-img {
      width: 15px;
    }
  }
  .click-tel {
    display: block;
    margin: 0 auto;
    margin-top: 32px;
    width: 100px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    color: #2ee9ff;
    border: 1px solid #2ee9ff;
    border-radius: 16px;
    border-radius: 16px;
  }
  .swiper-title-box {
    margin: 0 10px;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .swiper-title-left {
      font-size: 16px;
      font-weight: bolder;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 16px;
    }
    .swiper-title-right {
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: justify;
      line-height: 14px;
    }
  }
  .swiper-background {
    margin-top: 30px;
    margin-bottom: 30px;
    background: #000;
    .swiper-slide {
      // width: 130px !important;
      height: 81px;
    }
    .swiper-box {
      .video-slide {
        position: relative;
        width: 100%;
        height: 100%;
        .swiper-dialog {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            180deg,
            transparent 0%,
            rgba(0, 0, 0, 0.3) 100%
          );
          .user-play {
            position: absolute;
            top: 0;
            right: 0;
            padding: 3px 5px;
            font-size: 10px;
            color: #fff;
            background: rgba(255, 85, 52, 0.6);
          }
        }
        .cover-img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
        .cover-text-box {
          position: absolute;
          left: -5px;
          bottom: 0;
          width: 100%;
          transform: scale(0.8);
          .cover-date {
            font-size: 12px;
            color: #ffffff;
            letter-spacing: 0;
            line-height: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .cover-title {
            margin-top: 10px;
            width: 100%;
            font-size: 13px;
            color: #ffffff;
            letter-spacing: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .foot {
    margin-top: 61px;
    margin-bottom: 28px;
    .foot-img {
      display: block;
      margin: 0 auto;
      width: 148px;
    }
  }
}
</style>
